import { render } from "./pagination-content.vue?vue&type=template&id=aaa3efde"
import script from "./pagination-content.vue?vue&type=script&lang=js"
export * from "./pagination-content.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__